<template>
  <section class="contenedor">
    <div class="justify-content-center">
      <div class="col-md-12" v-if="cargando">
        <div v-for="i in numero" :key="i">
          <spinner />
          <spinner v-for="j in numeros[i]" :key="j" />
        </div>
      </div>

      <div class="contenedorBorder" v-else>
        <div class="kt-portlet__head-label" style="margin-top: 1rem">
          <h3 class="kt-portlet__head-title text-center">
            <b>Simulador mantenimientos prepagados</b>
          </h3>
          <h5 class="kt-portlet__head-title text-center">
            Calcula tu ahorro en nuestro simulador y comprueba nuestros beneficios
          </h5>
        </div>

        <form class="kt-portlet">
          <div class="container">
            <div class="form-group row" style="margin-top: 1rem">
              <div class="form-group col-md-6 col-12">
                <i class="fa fa-asterisk text-danger"></i>
                <label> Placa del auto </label>
                <input
                  type="text"
                  style="text-transform: uppercase; border: 1px solid #786c6c"
                  value=""
                  onkeyup="javascript:this.value=this.value.toUpperCase();"
                  class="form-control"
                  placeholder="PQA1234"
                  name="placa"
                  id="placa"
                  :maxlength="maxlength"
                  v-validate="{
                    required: true,
                    regex: /^[0-9A-Z]+$/,
                  }"
                  v-model="formulario.placa"
                />
                <span class="form-text text-danger">{{ errors.first("placa") }} </span>
              </div>

              <div class="form-group col-md-6 col-12">
                <i class="fa fa-asterisk text-danger"></i>
                <label>Provincia</label>
                <combo-box
                  style="border: 1px solid #786c6c; border-radius: 4px"
                  v-model="formulario.provincia"
                  :opciones="provincias"
                  name="provincia"
                  v-validate="{ required: true, obj: true }"
                >
                </combo-box>
                <span class="form-text text-danger">{{ errors.first("provincia") }}</span>
              </div>
            </div>

            <section class="container">
              <div class="container-fluid">
                <mapa
                  v-model="formulario.agencia"
                  :provincia="formulario.provincia"
                  @valoresDefecto="consultarProvincias"
                  @activar="ActivarBoton"
                >
                </mapa>
              </div>
            </section>
          </div>
        </form>

        <div class="boton" style="margin-left: 80%">
          <button
            type="button"
            class="btn btn-primary btn-font-sm"
            v-on:click="siguiente"
            :disabled="!botonActive || !formulario.placa || loading || this.cargando"
            :class="{ 'cursor-not-allowed': !botonActive }"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Loading...</span>
            </span>
            <span v-else>Continuar</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mapa from "../../componentes/kia-mapa";
import comboBox from "../../componentes/comboBox";
import * as servicios from "../../servicios";
import spinner from "./spinner";

export default {
  name: "Simulador",

  props: [],

  data: () => ({
    provincias: [],
    cargando: true,
    maxlength: 7,
    numero: 1,
    numeros: [],
    botonActive: false,
    loading: false,

    formulario: {
      provincia: { id: null },
      placa: null,
      agencia: { id: null },
    },
  }),

  components: {
    mapa,
    comboBox,
    spinner,
  },

  methods: {
    siguiente: function () {
      this.loading = true;
      servicios.buscarPlaca
        .buscarPlaca(this.formulario, process.env.VUE_APP_MARCA)
        .then((res) => {
          this.$store.commit("setHome", this.formulario);
          if (res.data.bdt1) {
            this.$store.commit("setVehiculo", res.data);
            this.loading = false;

            this.$router.push({
              name: "p3",
              params: {
                titulo: this.$route.params.titulo,
                id: this.$route.params.id,
              },
            });
          } else {
            this.$store.commit("setHome", this.formulario);
            this.$store.commit("setVehiculo", {
              dt3: null,
              dt6: null,
              dt7: null,
            });
            this.loading = false;
            this.$router.push({
              name: "p2",
              params: {
                titulo: this.$route.params.titulo,
                id: this.$route.params.id,
              },
            });
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    ActivarBoton(btn) {
      this.botonActive = btn;
    },

    consultarAplicacion: function () {
      this.cargando = true;
      servicios.aplicacion
        .obtenerAplicacion()
        .then((response) => {
          this.$store.commit("setAplicacion", response.data.id);
          //this.$store.commit("getAplicacion", response.data);
          this.cargando = false;
        })
        .catch((error) => {
          console.error("Error al obtener la aplicación:", error);
          this.cargando = false;
        });
    },
    consultarProvincias: function (res) {
      servicios.provincias.provincias(res.pais).then((response) => {
        this.provincias = response.data;
        const aux = response.data.find((i) => i.dt1 === res.provincia);
        this.formulario.provincia = { id: aux.id, dt1: aux.dt1 };
        this.botonActive = false;
      });
    },
  },

  mounted() {
    this.$store.commit("setManteniminetosCotizar", []);
    this.$store.commit("setVehiculo", null);
    this.$store.commit("setHome", null);

    this.consultarAplicacion();
  },
};
</script>

<style>
.contenedorBorder {
  width: 90%;
  padding-right: 10px;
  padding-left: 10px;
  margin-right: auto;
  margin-left: auto;
  border-bottom: solid;
  border-bottom-color: #05141f;
  border-bottom-width: 2.5px;
  border-bottom-right-radius: 35px;
  border-bottom-left-radius: 35px;
  border-top: solid;
  border-top-right-radius: 35px;
  border-top-left-radius: 35px;
  border-top-width: 2.5px;
}

.boton {
  margin-bottom: 1rem;
  margin-left: 10%;
}

.cursor-not-allowed {
  cursor: not-allowed;
}
</style>
